/**
 * Testimonials data for the landing page
 * Centralized location for easy maintenance and updates
 */
export const testimonials = [
  {
    id: 1,
    quote: "Thank you very much Ravana industries for handling my student visa for a tuition free public university in Germany. I received my visa in a week. I highly recommend them.",
    initials: "JK",
    name: "Jey Kison",
    rating: 5,
    country: "Germany",
    program: "Student Visa",
    verified: true
  },
  {
    id: 2,
    quote: "I got the assistance of Ravana Industries in obtaining my student visa for Germany. I appreciate their commitment and quick responses. They were always reachable and responded to us very calmly.",
    initials: "TP",
    name: "Tharani Paramasivam",
    rating: 5,
    country: "Germany",
    program: "Student Visa",
    verified: true
  },
  {
    id: 3,
    quote: "Ravana industry suggested by my brother for my future plan. At the start I'd a little bit fear but as I travelled with them through the process it's all disappeared.",
    initials: "ST",
    name: "Sanjeevan Thavachelvam",
    rating: 5,
    country: "Germany",
    program: "Student Visa",
    verified: true
  },
  {
    id: 4,
    quote: "Its good place for germany student visa service. I got the visa within 3 days. Honest talk and fast reply for your messages.",
    initials: "SV",
    name: "Sivakiri Varunikan",
    rating: 5,
    country: "Germany",
    program: "Student Visa",
    verified: true
  }
];

/**
 * Success metrics for social proof
 */
export const successMetrics = [
  {
    value: 500,
    label: "Successful Visas",
    suffix: "+",
    description: "Students placed in top universities"
  },
  {
    value: 99,
    label: "Success Rate",
    suffix: "%",
    description: "For qualified applicants"
  },
  {
    value: 5,
    label: "Countries",
    suffix: "",
    description: "Germany, Canada, Australia, UK, NZ"
  },
  {
    value: 100,
    label: "Client Satisfaction",
    suffix: "%",
    description: "Based on verified reviews"
  }
];

/**
 * Trust badges for the hero section
 */
export const trustBadges = [
  {
    icon: "✅",
    text: "99% Success Rate (Qualified Applicants)",
    highlight: true
  },
  {
    icon: "🏦",
    text: "Fintiba Official Partner",
    highlight: false
  },
  {
    icon: "🎓",
    text: "Free IELTS (PRO)",
    highlight: false
  },
  {
    icon: "🛡️",
    text: "Contract + Invoices Only",
    highlight: false
  },
  {
    icon: "📲",
    text: "Client Portal Access",
    highlight: false
  }
];
